// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as ButtonPhased from "../../resources/actions/ButtonPhased.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogSupplierTableEditCell from "./CatalogSupplierTableEditCell.res.js";
function CatalogSupplierTableEditCellWrapper(props) {
  let supplierName = props.supplierName;
  let supplierId = props.supplierId;
  let match = React.useState(() => false);
  let setFocused = match[1];
  let match$1 = Hover.use(undefined, undefined, undefined);
  let ref = match$1[0];
  ReactUpdateEffect.use1(() => {
    setFocused(param => false);
  }, [supplierId]);
  let newrecord = {
    ...{
      style: {
        marginLeft: "-10px"
      }
    }
  };
  let tmp;
  if (match[0]) {
    tmp = JsxRuntime.jsx(CatalogSupplierTableEditCell.make, {
      supplierId: supplierId,
      supplierName: supplierName,
      variantId: props.variantId,
      shopId: props.shopId,
      onDismiss: () => setFocused(param => false)
    });
  } else {
    let tmp$1 = supplierName === "" ? JsxRuntime.jsx(TextStyle.make, {
      children: I18n.t("To be filled"),
      variation: "subdued"
    }) : JsxRuntime.jsx(TextStyle.make, {
      children: supplierName
    });
    tmp = JsxRuntime.jsx(ButtonPhased.make, {
      children: tmp$1,
      hovered: match$1[1],
      onPress: () => setFocused(param => true),
      ref: ref
    });
  }
  newrecord.children = tmp;
  return JsxRuntime.jsx(Inline.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx("div", newrecord),
      spaceRight: "xxlarge",
      ref: ref
    })
  });
}
let make = React.memo(CatalogSupplierTableEditCellWrapper);
export { make };
/* make Not a pure module */